// extracted by mini-css-extract-plugin
export var csatScore = "_hx-5";
export var header = "_hx-1";
export var panelWrapper = "_hx-2";
export var postPreview = "_hx-3";
export var rightContent = "_hx-0";
export var wrappingText = "_hx-4";